import { useEffect, useMemo, useRef, useState } from "react";
import { Color, PointLight, Vector3 } from "three";
import store, { cameraStore } from "../../../../appStore";

import { useObjectCallback, useSheet } from "../../../../hooks/useTheatre";
import { findObjectStartsWithKey } from "../../../../utils/FindObjects";
import DragSphere from "../../DragSphere";

import fragmentShaderReplacement from "../../shader/VertexColorHeat_Distance_replacement_frag.glsl";
import fragmentShaderAddition from "../../shader/VertexColorHeat_Distance_addition_frag.glsl";

import vertexShaderReplacement from "../../shader/VertexColorHeat_Distance_replacement_vert.glsl";
import vertexShaderAddition from "../../shader/VertexColorHeat_Distance_addition_vert.glsl";

const LightName = "Minac_Light_Brazing";

const MinacInteraction = ({ action, scene, ...props }) => {
  const sheet = useSheet("EFD", "MINAC_INTERACTION", "0");

  const [dragActive, setDragActive] = useState(true);

  const heatSource = useMemo(() => {
    return findObjectStartsWithKey("1_Light_target", scene);
  });

  const [workpiece] = useMemo(() => {
    var workpiece = findObjectStartsWithKey("ME_Brazing_Workpiece", scene);

    var heatSourceWorld = new Vector3();
    heatSource.getWorldPosition(heatSourceWorld);

    var materialClone = workpiece.material.clone();

    materialClone.onBeforeCompile = (s) => {
      s.uniforms.uHeat = {
        value: 0.0,
      };
      s.uniforms.uHeatFallof = {
        value: 0.9,
      };
      s.uniforms.uHardened = {
        value: 1.0,
      };
      s.uniforms.uHeatSource = {
        value: heatSourceWorld,
      };
      s.uniforms.uHeatDistance = {
        value: 9,
      };
      s.vertexShader = `${vertexShaderAddition}${s.vertexShader}`;
      s.vertexShader = s.vertexShader.replace(`#include <fog_vertex>`, vertexShaderReplacement);

      s.fragmentShader = `${fragmentShaderAddition}\n${s.fragmentShader}`;
      s.fragmentShader = s.fragmentShader.replace(`#include <color_fragment>`, ``);
      s.fragmentShader = s.fragmentShader.replace(`#include <dithering_fragment>`, fragmentShaderReplacement);

      materialClone.userData.shader = s;
    };

    workpiece.material = materialClone;

    return [workpiece];
  }, []);

  const Light = useMemo(() => {
    var l = findObjectStartsWithKey(LightName, scene);
    if (l) return l;

    var target = heatSource;

    var light = new PointLight(new Color("#a85332"), 0);

    // light.add(debugSphere);
    light.position.copy(target.position);
    light.name = LightName;
    light.distance = 0.5;
    light.decay = 1;
    target.add(light);
    light.position.copy(new Vector3());

    return light;
  }, []);

  const heatSourceWorldPosition = useMemo(() => {
    return new Vector3();
  }, []);

  const animationConfig = useMemo(() => {
    return {
      animationTime: 0,
      heatIntesity: 0,
      lightIntesity: 0,
    };
  }, []);

  useObjectCallback(sheet, "Animation", animationConfig, ({ animationTime, heatIntesity, lightIntesity }) => {
    action.time = sheet.sequence.position;

    if (Light) {
      Light.intensity = lightIntesity;
    }

    heatSource.getWorldPosition(heatSourceWorldPosition);

    if (workpiece.material.userData.shader) {
      workpiece.material.userData.shader.uniforms.uHeatSource.value = heatSourceWorldPosition;

      workpiece.material.userData.shader.uniforms.uHeat.value = heatIntesity;
      // workpiece.material.userData.shader.uniforms.uHardened.value = hardened;
    }
  });

  useEffect(() => {
    cameraStore.rotateWithMouse = false;

    action.reset().play().fadeIn(0.5);
    action.play();
    action.paused = true;
    sheet.sequence.position = 0;
    // sheet.sequence.play({ iterationCount: Infinity });
    return () => {
      cameraStore.rotateWithMouse = true;
      cameraStore.enabled = true;
      sheet.sequence.position = 0;
      sheet.sequence.pause();
      action.time = 0;
      action.fadeOut(0.5);
    };
  }, []);

  const dragPoints = useMemo(() => {
    let startPos = new Vector3();
    var startObj = findObjectStartsWithKey("1_Drag_Start", scene);
    startObj.getWorldPosition(startPos);

    let endPos = new Vector3();
    var endObj = findObjectStartsWithKey("1_Drag_End", scene);
    endObj.getWorldPosition(endPos);

    return [startPos, endPos];
  }, [scene]);

  const handleDrag = (v) => {
    sheet.sequence.position = v * 0.8;
  };

  const handleDragComplete = () => {
    cameraStore.enabled = true;
    sheet.sequence.play({ iterationCount: 1 }).then(() => setDragActive(true));
    setDragActive(false);
  };

  return (
    <group>
      {dragActive && (
        <DragSphere
          lineStart={dragPoints[0]}
          lineEnd={dragPoints[1]}
          onDrag={handleDrag}
          onComplete={handleDragComplete}
          planeRotation={90}
          sphereRadius={0.015}
          id="minac_1"
          // debug
        />
      )}
    </group>
  );
};

export default MinacInteraction;
